const root = document.querySelector(':root');

export default (n, v) => {
    const parts = n.indexOf('.') > -1 ? n.split('.') : [n, v];
    const styles = getComputedStyle(root);
    const value = styles.getPropertyValue(`--flipboard-${parts.join('-')}`).trim();

    if (!value || value.length === 0) {
        console.warn(`No value found for style ${n}${v ? `.${v}` : ''}`);
    }

    return value;
};
